import Vue from 'vue'
import Xloading from '../../components/elementCommen/elProgress'
const XLOADING = {
    install(Vue){
        if (typeof window !== 'undefined' && window.Vue) {
            Vue = window.Vue
        }
        Vue.component('XLoading', Xloading)
        let VueLoading = Vue.extend({
            render(h) {
                //传递给 elProgress 组件中的show使用
                let props = {
                    show: this.show
                }
                return h('x-loading', {props})
            },
            data() {
                return {
                    show: false
                }
            }
        })
        let newLoading = new VueLoading()
        let vm = newLoading.$mount()
        let el = vm.$el
        document.body.appendChild(el) // 把生成的提示的dom插入body中
        vm.show = false
        function loading (b){
            vm.show = b
        }
        // 挂载到vue原型上，暴露2个方法
        Vue.prototype.$xLoading = {
            show() {
                loading(true)
            },
            close(){
                loading(false)
            },
        }
    }
}
export default XLOADING;



// WEBPACK FOOTER //
// ./src/assets/js/xLoading.js